import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const hdr = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const DURUMLAR_EYLEM = [
  { value: 'beklemede',  label: 'Beklemede',  renk: '#95a5a6' },
  { value: 'devam',      label: 'Devam Ediyor', renk: '#3498db' },
  { value: 'tamamlandi', label: 'Tamamlandı', renk: '#27ae60' },
  { value: 'gecikti',    label: 'Gecikti',    renk: '#e74c3c' },
  { value: 'iptal',      label: 'İptal',      renk: '#7f8c8d' },
];
const DURUM_RENK: Record<string, string> = {
  beklemede: '#95a5a6', devam: '#3498db', tamamlandi: '#27ae60', gecikti: '#e74c3c', iptal: '#7f8c8d',
};
const KARAR_DURUM_RENK: Record<string, string> = {
  beklemede: '#95a5a6', devam: '#3498db', tamamlandi: '#27ae60', iptal: '#7f8c8d',
};

const emptyEylem = { aciklama: '', sorumlu_personel_id: '', sorumlu_birim_id: '', son_tarih: '', durum: 'beklemede', notlar: '' };

export default function IsTakipDetay() {
  const { id } = useParams();
  const nav = useNavigate();
  const [konu,       setKonu]       = useState<any>(null);
  const [personeller, setPersoneller] = useState<any[]>([]);
  const [birimler,   setBirimler]   = useState<any[]>([]);
  const [eylemModal, setEylemModal] = useState(false);
  const [seciliEylem,setSeciliEylem]= useState<any>(null);
  const [eylemForm,  setEylemForm]  = useState<any>({ ...emptyEylem });
  const [hata,       setHata]       = useState('');
  const [yuk,        setYuk]        = useState(false);
  const [dosyaYuk,   setDosyaYuk]   = useState(false);
  const dosyaRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    fetch(`${API}/api/is-takip/referans/personel`, { headers: hdr() }).then(r => r.json()).then(d => setPersoneller(Array.isArray(d) ? d : [])).catch(() => {});
    fetch(`${API}/api/is-takip/referans/birimler`,  { headers: hdr() }).then(r => r.json()).then(d => setBirimler(Array.isArray(d) ? d : [])).catch(() => {});
    yukle();
  }, [id]);

  const yukle = () => {
    fetch(`${API}/api/is-takip/konular/${id}`, { headers: hdr() })
      .then(r => r.json()).then(setKonu).catch(() => {});
  };

  const eylemAc = (e?: any) => {
    setSeciliEylem(e || null);
    setEylemForm(e ? {
      aciklama: e.aciklama, sorumlu_personel_id: e.sorumlu_personel_id ? String(e.sorumlu_personel_id) : '',
      sorumlu_birim_id: e.sorumlu_birim_id ? String(e.sorumlu_birim_id) : '',
      son_tarih: e.son_tarih || '', durum: e.durum, notlar: e.notlar || '',
    } : { ...emptyEylem, konu_id: id });
    setHata(''); setEylemModal(true);
  };

  const eylemKaydet = async () => {
    if (!eylemForm.aciklama.trim()) { setHata('Açıklama zorunludur'); return; }
    setHata(''); setYuk(true);
    const body = {
      konu_id: Number(id),
      aciklama: eylemForm.aciklama,
      sorumlu_personel_id: eylemForm.sorumlu_personel_id ? Number(eylemForm.sorumlu_personel_id) : null,
      sorumlu_birim_id:    eylemForm.sorumlu_birim_id    ? Number(eylemForm.sorumlu_birim_id)    : null,
      son_tarih: eylemForm.son_tarih || null,
      durum:     eylemForm.durum,
      notlar:    eylemForm.notlar || null,
    };
    try {
      const url    = seciliEylem ? `${API}/api/is-takip/eylemler/${seciliEylem.id}` : `${API}/api/is-takip/eylemler`;
      const method = seciliEylem ? 'PUT' : 'POST';
      await fetch(url, { method, headers: { ...hdr(), 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      setEylemModal(false); yukle();
    } catch { setHata('Kayıt hatası'); }
    finally { setYuk(false); }
  };

  const eylemSil = async (eid: number) => {
    if (!window.confirm('Bu eylem silinsin mi?')) return;
    await fetch(`${API}/api/is-takip/eylemler/${eid}`, { method: 'DELETE', headers: hdr() });
    yukle();
  };

  const dosyaYukle = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0]; if (!f) return;
    setDosyaYuk(true);
    const fd = new FormData(); fd.append('dosya', f);
    await fetch(`${API}/api/is-takip/dosya-yukle/konu/${id}`, { method: 'POST', headers: hdr(), body: fd });
    setDosyaYuk(false); yukle();
    if (dosyaRef.current) dosyaRef.current.value = '';
  };

  const dosyaSil = async (did: number) => {
    if (!window.confirm('Dosya silinsin mi?')) return;
    await fetch(`${API}/api/is-takip/dosyalar/${did}`, { method: 'DELETE', headers: hdr() });
    yukle();
  };

  const inp = (field: string) => (e: any) => setEylemForm((f: any) => ({ ...f, [field]: e.target.value }));

  if (!konu) return <div style={{ padding: 32, color: '#888' }}>Yükleniyor...</div>;

  const bugun = new Date();

  return (
    <div style={{ padding: '20px 24px', maxWidth: 960 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <button onClick={() => nav('/is-takip')} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: '#888' }}>←</button>
        <h2 style={{ margin: 0, fontSize: 17, color: '#1a3c5e' }}>{konu.baslik}</h2>
        <span style={{ fontSize: 11, background: `${DURUM_RENK[konu.durum] || '#ccc'}22`,
          color: DURUM_RENK[konu.durum], padding: '3px 9px', borderRadius: 10 }}>
          {konu.durum}
        </span>
      </div>

      {/* Konu Bilgileri */}
      <div style={{ background: '#fff', borderRadius: 10, padding: '16px 20px', marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,.06)' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(180px,1fr))', gap: 10, fontSize: 12 }}>
          {[
            ['Kategori', konu.kategori], ['Öncelik', konu.oncelik],
            ['Sorumlu Birim', konu.sorumlu_birim_ad || '—'],
            ['İlgili İşletme', konu.ilgili_isletme_ad || '—'],
            ['Başlangıç', konu.baslangic_tarihi || '—'],
            ['Son Tarih', konu.son_tarih || '—'],
            ['Oluşturan', konu.olusturan_ad || '—'],
          ].map(([l, v]) => (
            <div key={l}><span style={{ color: '#888' }}>{l}: </span><span style={{ fontWeight: 600 }}>{v}</span></div>
          ))}
        </div>
        {konu.aciklama && <p style={{ marginTop: 10, marginBottom: 0, fontSize: 13, color: '#444', lineHeight: 1.5 }}>{konu.aciklama}</p>}
      </div>

      {/* Eylemler */}
      <div style={{ background: '#fff', borderRadius: 10, padding: '14px 16px', marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,.06)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <span style={{ fontWeight: 700, fontSize: 14, color: '#1a3c5e' }}>Eylemler ({konu.eylemler?.length || 0})</span>
          <button onClick={() => eylemAc()} style={{ background: '#1a5276', color: '#fff', border: 'none', borderRadius: 6, padding: '5px 12px', cursor: 'pointer', fontSize: 12 }}>+ Eylem Ekle</button>
        </div>

        {konu.eylemler?.length === 0 && <div style={{ color: '#bbb', fontSize: 12, padding: '8px 0' }}>Henüz eylem eklenmemiş</div>}
        {konu.eylemler?.map((e: any) => {
          const gecikti = e.son_tarih && new Date(e.son_tarih) < bugun && e.durum !== 'tamamlandi';
          return (
            <div key={e.id} style={{ border: `1px solid ${gecikti ? '#fcc' : '#eee'}`, borderRadius: 8, padding: '10px 12px', marginBottom: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 4 }}>{e.aciklama}</div>
                  <div style={{ display: 'flex', gap: 12, fontSize: 11, color: '#888', flexWrap: 'wrap' }}>
                    {e.sorumlu_personel_ad && <span>👤 {e.sorumlu_personel_ad}</span>}
                    {e.sorumlu_birim_ad    && <span>🏢 {e.sorumlu_birim_ad}</span>}
                    {e.son_tarih && <span style={{ color: gecikti ? '#e74c3c' : '#888' }}>📅 {e.son_tarih}{gecikti ? ' ⚠️' : ''}</span>}
                    {e.notlar && <span>📝 {e.notlar.slice(0, 40)}</span>}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginLeft: 12 }}>
                  <select value={e.durum}
                    onChange={async (ev) => {
                      await fetch(`${API}/api/is-takip/eylemler/${e.id}`, {
                        method: 'PUT', headers: { ...hdr(), 'Content-Type': 'application/json' },
                        body: JSON.stringify({ konu_id: Number(id), aciklama: e.aciklama, durum: ev.target.value }),
                      }); yukle();
                    }}
                    style={{ fontSize: 11, padding: '2px 6px', borderRadius: 5, border: `1px solid ${DURUM_RENK[e.durum] || '#ccc'}`, color: DURUM_RENK[e.durum] }}>
                    {DURUMLAR_EYLEM.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                  </select>
                  <button onClick={() => eylemAc(e)} style={{ background: 'none', border: '1px solid #ddd', borderRadius: 5, padding: '2px 7px', cursor: 'pointer', fontSize: 11 }}>✎</button>
                  <button onClick={() => eylemSil(e.id)} style={{ background: 'none', border: '1px solid #fcc', borderRadius: 5, padding: '2px 7px', cursor: 'pointer', fontSize: 11, color: '#e74c3c' }}>✕</button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* İlgili Toplantı Kararları */}
      {konu.ilgili_kararlar?.length > 0 && (
        <div style={{ background: '#fff', borderRadius: 10, padding: '14px 16px', marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,.06)' }}>
          <div style={{ fontWeight: 700, fontSize: 14, color: '#1a3c5e', marginBottom: 10 }}>Bağlı Toplantı Kararları</div>
          {konu.ilgili_kararlar.map((kr: any) => (
            <div key={kr.karar_id} style={{ borderBottom: '1px solid #f5f5f5', padding: '7px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <span style={{ fontSize: 12, color: '#333' }}>{kr.karar_metni.slice(0, 80)}</span>
                <span style={{ fontSize: 11, color: '#888', marginLeft: 10 }}>
                  {kr.toplanti_baslik} · {kr.toplanti_tarih?.slice(0, 10)}
                </span>
              </div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <span style={{ fontSize: 11, background: `${KARAR_DURUM_RENK[kr.durum] || '#ccc'}22`, color: KARAR_DURUM_RENK[kr.durum], padding: '2px 7px', borderRadius: 10 }}>{kr.durum}</span>
                <button onClick={() => nav(`/toplanti/${kr.toplanti_id}`)}
                  style={{ background: 'none', border: '1px solid #ddd', borderRadius: 5, padding: '2px 8px', cursor: 'pointer', fontSize: 11 }}>Toplantı →</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Dosyalar */}
      <div style={{ background: '#fff', borderRadius: 10, padding: '14px 16px', boxShadow: '0 1px 4px rgba(0,0,0,.06)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <span style={{ fontWeight: 700, fontSize: 14, color: '#1a3c5e' }}>Ekler ({konu.dosyalar?.length || 0})</span>
          <label style={{ background: '#1a5276', color: '#fff', border: 'none', borderRadius: 6, padding: '5px 12px', cursor: 'pointer', fontSize: 12 }}>
            {dosyaYuk ? 'Yükleniyor...' : '+ Dosya Ekle'}
            <input ref={dosyaRef} type="file" style={{ display: 'none' }} onChange={dosyaYukle} />
          </label>
        </div>
        {konu.dosyalar?.length === 0 && <div style={{ color: '#bbb', fontSize: 12 }}>Ek dosya yok</div>}
        {konu.dosyalar?.map((d: any) => (
          <div key={d.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #f5f5f5', padding: '6px 0' }}>
            <a href={`${API}${d.url}`} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#1a5276', textDecoration: 'none' }}>
              📎 {d.dosya_adi}
            </a>
            <div style={{ display: 'flex', gap: 8, fontSize: 11, color: '#888', alignItems: 'center' }}>
              <span>{d.yukleyen_ad}</span>
              <span>{d.yuklenme_tarihi?.slice(0, 10)}</span>
              <button onClick={() => dosyaSil(d.id)} style={{ background: 'none', border: '1px solid #fcc', borderRadius: 5, padding: '2px 6px', cursor: 'pointer', fontSize: 11, color: '#e74c3c' }}>Sil</button>
            </div>
          </div>
        ))}
      </div>

      {/* Eylem Modal */}
      {eylemModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 26, width: 480, boxShadow: '0 8px 32px rgba(0,0,0,.2)' }}>
            <h3 style={{ margin: '0 0 18px', fontSize: 15 }}>{seciliEylem ? 'Eylem Düzenle' : 'Yeni Eylem'}</h3>

            <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Açıklama *</label>
            <textarea value={eylemForm.aciklama} onChange={inp('aciklama')} rows={3}
              style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', marginBottom: 12, boxSizing: 'border-box', fontSize: 13, resize: 'vertical' }} />

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
              <div>
                <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Sorumlu Personel</label>
                <select value={eylemForm.sorumlu_personel_id} onChange={inp('sorumlu_personel_id')}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}>
                  <option value="">Seçiniz</option>
                  {personeller.map((p: any) => <option key={p.id} value={p.id}>{p.ad_soyad}</option>)}
                </select>
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Sorumlu Birim</label>
                <select value={eylemForm.sorumlu_birim_id} onChange={inp('sorumlu_birim_id')}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}>
                  <option value="">Seçiniz</option>
                  {birimler.map((b: any) => <option key={b.id} value={b.id}>{b.ad}</option>)}
                </select>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
              <div>
                <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Son Tarih</label>
                <input type="date" value={eylemForm.son_tarih} onChange={inp('son_tarih')}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Durum</label>
                <select value={eylemForm.durum} onChange={inp('durum')}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}>
                  {DURUMLAR_EYLEM.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                </select>
              </div>
            </div>

            <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Notlar</label>
            <textarea value={eylemForm.notlar} onChange={inp('notlar')} rows={2}
              style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', marginBottom: 14, boxSizing: 'border-box', fontSize: 13, resize: 'vertical' }} />

            {hata && <div style={{ color: '#e74c3c', fontSize: 12, marginBottom: 8 }}>{hata}</div>}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setEylemModal(false)} style={{ padding: '6px 16px', borderRadius: 6, border: '1px solid #ddd', cursor: 'pointer', fontSize: 13 }}>İptal</button>
              <button onClick={eylemKaydet} disabled={yuk}
                style={{ padding: '6px 16px', borderRadius: 6, background: '#1a5276', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 13, opacity: yuk ? .6 : 1 }}>
                {yuk ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
